export default "__VITE_ASSET__CumubEDC__"